import {http_get, copy_attributes, parse_xml} from 'lib/utilities';
import Bus from 'lib/bus';
import Store from 'lib/store';

export default function LazySvgs(selector = 'svg[data-src]') {
    const bus = Bus();

    constructor();

    function constructor() {
        findElements()
            .map(element => LazySvg(element, onLoad));
    }

    function findElements() {
        return Array.from(document.querySelectorAll(selector));
    }

    function onLoad(svgElement) {
        bus.emit('load', svgElement);
    }

    return {
        on: bus.on,
        off: bus.off
    }
}

// Store for promises for SVGs currently loading
LazySvgs.loading = Store();

// Store for loaded SVGs
LazySvgs.cache = Store();

export function LazySvg(placeholder, callback) {
    constructor();

    async function constructor() {
        const svg = await resolveSVG();

        replacePlaceholder(svg);
    }

    function getSourceUrl() {
        return placeholder.getAttribute('data-src');
    }

    /**
     * Resolve the SVG element.
     *
     * @return {Promise<SVGElement>}
     */
    async function resolveSVG() {
        const url = getSourceUrl();

        if (LazySvgs.cache.has(url)) {
            return getCached(url);
        } else if (LazySvgs.loading.has(url)) {
            // If one is already loading, wait for its promise
            return await awaitLoading(url);
        } else {
            return await load(url);
        }
    }

    function getCached(url) {
        return parseSVG(
            LazySvgs.cache.get(url)
        );
    }

    /**
     * Load an SVG.
     *
     * @param url
     * @returns {Promise<SVGElement>}
     */
    async function load(url) {
        const promise = http_get(url);

        // Cache the promise so other instances of the same SVG can await  its resolution
        LazySvgs.loading.set(url, promise);

        const xml = await promise;

        // Once it's loaded, remove the cached promise...
        LazySvgs.loading.remove(url);

        const svg = parseSVG(xml);

        // ...and cache the XML
        LazySvgs.cache.set(url, xml);

        return svg;
    }

    async function awaitLoading(url) {
        const xml = await LazySvgs.loading.get(url);

        return parseSVG(xml)
    }

    /**
     * Validate the given value.
     *
     * @param {*} svgElement
     * @return {SVGElement} - Returns the given value if it is an SVGElement
     */
    function validateSvg(svgElement) {
        if (svgElement instanceof SVGElement) {
            return svgElement;
        }

        throw new Error('[LazySvg]: Invalid SVG at url: ' + getSourceUrl());
    }

    /**
     * Parse the given XML string and get an SVG element.
     *
     * @param {string} xml
     * @return {Promise<SVGElement>}
     */
    async function parseSVG(xml) {
        const elements = parse_xml(xml);

        return validateSvg(elements[0]);
    }

    function replacePlaceholder(svg) {
        const parent = placeholder.parentElement || placeholder.parentNode;

        copy_attributes(placeholder, svg, [
            'data-src'
        ]);

        // Move SVG outside of placeholder, to a new position just before the placeholder in the parent
        parent.insertBefore(svg, placeholder);

        // Remove the placeholder
        parent.removeChild(placeholder);

        callback(svg);
    }
}